import React, { Component } from "react";
import Slider from "react-slick";

//IMPORT IMAGES
import headerAfter from '../../frontend/assets/img/shape/header-after.png';
import heroAfter from '../../frontend/assets/img/shape/hero-after.png';
import hcontentBg from '../../frontend/assets/img/shape/hcontent-bg.png';
import heroConBefore from '../../frontend/assets/img/shape/hero-con-before.png';
import heroConAfter from '../../frontend/assets/img/shape/hero-con-after.png';
import headerFloat from '../../frontend/assets/img/Jainism/headerfloat.png';
import { BASEURL } from "../../Global";

class CustomSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sliderData: []
        };
    }

    async fetchSlider() {
        try {
            await fetch(`${BASEURL}/searchandlistslider`, {
                method: "GET",
                headers: {
                    Accept: 'application/json',
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        response.json().then(responseJson => {
                            if (responseJson.data) {
                                this.setState({ sliderData: responseJson.data })
                            } else {
                                // console.log("Data Not Found !!")
                            }
                        })
                    } else {
                        // console.log("Something Went Wrong !!")
                    }
                })
                .catch((error) => console.error(error));
        } catch (e) {
            console.log("ERROR", e)
        }
    }

    componentDidMount() {
        this.fetchSlider()
    }
    render() {

        const settings = {
            dots: false,
            fade: true,
            infinite: true,
            speed: 2000,
            slidesToShow: 1,
            slidesToScroll: 1,
            waitForAnimate: false,
            autoplay: true,
            autoplaySpeed: 2000,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };

        return (
            <React.Fragment>
                <section className="vs-hero-wrapper position-relative new-slider">
                    <div className=" section-before">
                        <img src={headerAfter} alt="shape" />
                    </div>
                    <div className="section-after d-none d-md-block">
                        <img src={heroAfter} alt="shape" />
                    </div>
                    <Slider {...settings} >
                        {/* <div className="hero-slider1 vs-carousel" data-slide-show="1" data-md-slide-show="1" data-fade="true">
                            <div className="vs-hero-inner">
                                <img className="vs-hero-bg" src={heroImage1} />
                                <div className="hero-content" style={{ backgroundImage: `url(${hcontentBg})` }}>
                                    <img className="con-before slideinleft vs-animated" data-ani="slideinleft" data-ani-delay="0.2s"
                                        src={heroConBefore} alt="shape" />
                                    <img className="con-after slideinright vs-animated" data-ani="slideinright" data-ani-delay="0.2s"
                                        src={heroConAfter} alt="shape" />
                                    <img className="car slidetopleft vs-animated " data-ani="slidetopleft" data-ani-delay="0.4s"
                                        src={headerFloat} alt="icon" />

                                    <h1 className="hero-title text-title mb-30 slideinup vs-animated" data-ani="slideinup" data-ani-delay="0.2s">Welcome To<span
                                        className="focus text-theme">MyJainism</span> "Ek Sanskar Mandir"</h1>
                                    <a href="#" className="vs-btn wave-btn slideinup vs-animated" data-ani="slideinup" data-ani-delay="0.4s">About Us</a>
                                </div>
                            </div>
                        </div>
                        <div className="hero-slider1 vs-carousel" data-slide-show="1" data-md-slide-show="1" data-fade="true">
                            <div className="vs-hero-inner">
                                <div className="vs-hero-bg" style={{ backgroundImage: `url(${heroImage2})` }}></div>
                                <div className="hero-content" style={{ backgroundImage: `url(${hcontentBg})` }}>
                                    <img onFocus={() => console.log("Loadedddd")} className="con-before slideinleft vs-animated" data-ani="slideinleft" data-ani-delay="0.2s"
                                        src={heroConBefore} alt="shape" />
                                    <img className="con-after slideinright vs-animated" data-ani="slideinright" data-ani-delay="0.2s"
                                        src={heroConAfter} alt="shape" />
                                    <img className="car slidetopleft vs-animated " data-ani="slidetopleft" data-ani-delay="0.4s"
                                        src={headerFloat} alt="icon" />

                                    <h1 className="hero-title text-title mb-30 slideinup vs-animated" data-ani="slideinup" data-ani-delay="0.2s">Welcome To<span
                                        className="focus text-theme">MyJainism</span> "Ek Sanskar Mandir"</h1>
                                    <a href="#" className="vs-btn wave-btn slideinup vs-animated" data-ani="slideinup" data-ani-delay="0.4s">Contact Us</a>
                                </div>
                            </div>
                        </div> */}
                        {this.state.sliderData?.map((item , ind) => {
                            return (
                                <div className="hero-slider1 vs-carousel" data-slide-show="1" data-md-slide-show="1" data-fade="true" key={ind}>
                                    <div className="vs-hero-inner">
                                        <div className="vs-hero-bg"
                                            style={{
                                                backgroundImage: `url(${item.image})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                backgroundRepeat: "no-repeat"
                                            }}></div>
                                        <div className="hero-content" style={{ backgroundImage: `url(${hcontentBg})` }}>
                                            <img onFocus={() => console.log("Loadedddd")} className="con-before slideinleft vs-animated" data-ani="slideinleft" data-ani-delay="0.2s"
                                                src={heroConBefore} alt="shape" />
                                            <img className="con-after slideinright vs-animated" data-ani="slideinright" data-ani-delay="0.2s"
                                                src={heroConAfter} alt="shape" />
                                            <img className="car slidetopleft vs-animated " data-ani="slidetopleft" data-ani-delay="0.4s"
                                                src={headerFloat} alt="icon" />

                                            <h1 className="hero-title text-title mb-30 slideinup vs-animated" data-ani="slideinup" data-ani-delay="0.2s">Welcome To<span
                                                className="focus text-theme">MyJainism</span> "Ek Sanskar Mandir"</h1>
                                            <a href={process.env.PUBLIC_URL + "/contact-us"} className="vs-btn wave-btn slideinup vs-animated" data-ani="slideinup" data-ani-delay="0.4s">Contact Us</a>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </section>
            </React.Fragment >
        );
    }
}

export default CustomSlider;
